import { render, staticRenderFns } from "./DeliveryTypeStatus.vue?vue&type=template&id=2d856bbe&"
import script from "./DeliveryTypeStatus.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports